import { CONTENT_CATEGORY_ID } from '@/constants';
import { fetchAllFromCache, FetchAPIOptions } from './api';
import { fetchAllFromWordpressAndCache } from './wordpress-api';

export interface PaperProp {
  id: number;
  title: string;
  journal: string;
  year: number;
  link: string;
  category: string[];
}

const GET_PUBLICATIONS_QUERY = `
query getPublications($categoryId: Int!, $postCount: Int!, $after: String) {
  posts(
    first: $postCount,
    where: {
      categoryId: $categoryId,
      status: PUBLISH
    },
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        title
        link
        thesis {
          category
          url
          year
          journal
        }
      }
    }
  }
}`;

/**
 * WordPress에서 논문 목록을 가져와 S3에 캐시 (refresh용)
 */
const fetchPublicationsFromWordpress = async (
  label: string,
  options?: { prodFilter?: boolean },
) => {
  return fetchAllFromWordpressAndCache(
    {
      query: GET_PUBLICATIONS_QUERY,
      getVariables: cursor => ({
        categoryId: CONTENT_CATEGORY_ID.publications,
        postCount: 100,
        after: cursor,
      }),
      getPageInfo: data => ({
        hasNextPage: data?.posts?.pageInfo?.hasNextPage || false,
        endCursor: data?.posts?.pageInfo?.endCursor || null,
      }),
      getItems: data => data?.posts?.edges || [],
    },
    { label, prodFilter: options?.prodFilter },
  );
};

/**
 * S3 캐시에서 논문 목록을 가져옴 (빌드/런타임용)
 */
const fetchPublicationsFromCache = async (label: string) => {
  return fetchAllFromCache(
    {
      getPageInfo: data => ({
        hasNextPage: data?.posts?.pageInfo?.hasNextPage || false,
      }),
      getItems: data => data?.posts?.edges || [],
      postCount: 100,
    },
    { label },
  );
};

export const getPublications = async (
  options?: FetchAPIOptions,
): Promise<PaperProp[]> => {
  try {
    const label = 'getPublications';
    const refresh = options?.refresh ?? false;

    const data = refresh
      ? await fetchPublicationsFromWordpress(label, {
          prodFilter: options?.prodFilter,
        })
      : await fetchPublicationsFromCache(label);

    return (
      data?.map((edge: any) => ({
        id: edge.node.id,
        title: edge.node.title,
        link: edge.node.thesis.url,
        year: edge.node.thesis.year,
        category: edge.node.thesis.category,
        journal: edge.node.thesis.journal,
      })) || []
    );
  } catch (error) {
    return [];
  }
};
